import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AlertComponent} from './shared/ui/alert/alert.component';
import {ConfirmComponent} from './shared/ui/confirm/confirm.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    AlertComponent,
    ConfirmComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {

}
